import $ from 'jquery'
import { GeoJSON } from 'ol/format'
import { createEmpty, extend } from 'ol/extent'
/**
 * @module
 * @api
 */

/**
 * Zoom class
 *
 * @param {Object} config Olga configuration
 * @constructor
 */
export default function Zoom(config) {
  $.extend(this, config)
}

/**
 * Zoom to matching feature property
 * @param {string|string[]} property Property name or an array of properties
 * @param {*} value Value or an array of values
 * @param {string=} layerName
 * @return {bool} Returns false if no features were found
 * @memberof! module:api/Zoom#
 * @api
 */
Zoom.prototype.toProperty = function(property, value, layerName) {
  if (!layerName) {
    layerName = this.layer.getDefaultLayerName()
  }

  var layer = this.layer.getLayerByName(layerName)
  var featuresFound = this.geometry.getFeatureByProperty(layer, property, value)

  if (featuresFound.length < 1) {
    return false
  }

  var geometry = featuresFound[0].getGeometry()
  var extent = geometry.getExtent()
  var mapSize = this.map.getSize()

  this.map.getView().fit(extent, mapSize)

  return true
}

/**
 * Zoom to matching feature properties
 * @param {array} filters Array of filter objects
 * @param {string=} layerName
 * @return {bool} Returns false if no features were found
 * @memberof! module:api/Zoom#
 * @api
 */
Zoom.prototype.toCollectionByProperties = function(filters, layerName) {
  if (!layerName) {
    layerName = this.layer.getDefaultLayerName()
  }

  var layer = this.layer.getLayerByName(layerName)
  var featuresExtent = createEmpty()

  var featuresFound = 0

  filters.forEach(
    function(filter) {
      var features = this.geometry.getFeatureByProperty(
        layer,
        filter.property,
        filter.value
      )
      features.forEach(
        function(feature) {
          extend(featuresExtent, feature.getGeometry().getExtent())
          featuresFound++
        }.bind(this)
      )
    }.bind(this)
  )

  if (featuresFound > 0) {
    var mapSize = this.map.getSize()
    this.map.getView().fit(featuresExtent, mapSize)
    return true
  } else {
    return false
  }
}

/**
 * Zoom to geometry
 * @param {geojson} geometry Map extent and center will be calculated based on this geometry
 * @memberof! module:api/Zoom#
 * @api
 */
Zoom.prototype.toGeometry = function(geometry) {
  var geo = new GeoJSON()
  var parsedGeom = geo.readGeometry(geometry)
  var extent = parsedGeom.getExtent()
  var mapSize = this.map.getSize()
  this.map.getView().fit(extent, mapSize)
}
